import { Component } from 'react';
import PropTypes from 'prop-types';
import BackendApiService from '../../services/BackendApiService';
import PreAdmissionDetail from '../pre-admission-detail/PreAdmissionDetail';
import logCaughtException from '../../helpers/logCaughtException';

class PreAdmissionDetailContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      preAdmissionData: null,
      loading: true,
    };
  }

  componentDidMount() {
    // React ignores whatever this lifecycle returns, so the promise has to be
    // terminated here or a rejection becomes an unhandled one.
    this.loadPreAdmissionData().catch(logCaughtException);
  }

  async loadPreAdmissionData() {
    try {
      const preAdmissionData = await BackendApiService.getPreAdmissionData(this.props.preAdmissionId);
      if (preAdmissionData) {
        this.setState({ loading: false, preAdmissionData });
      } else {
        this.setState({ loading: false, preAdmissionData: null });
      }
    } catch (e) {
      console.error(e);
      this.setState({ loading: false, preAdmissionData: null });
    }
  }

  render() {
    if (this.state.loading) {
      return (<div>Cargando datos</div>);
    }
    if (!this.state.preAdmissionData) {
      return (<div>No tiene permisos a este preingreso.</div>);
    }
    return <PreAdmissionDetail preAdmissionData={this.state.preAdmissionData} />;
  }
}

PreAdmissionDetailContainer.propTypes = {
  preAdmissionId: PropTypes.string,
};

export default PreAdmissionDetailContainer;
